export default "__VITE_ASSET__D7pE5YHt__"